module.exports = __webpack_public_path__ + "static/media/envelope.00886f84.svg";